// Minnesota ZIP → [County, TaxRate] lookup (metro area + major cities)
export const MN_ZIP_TO_COUNTY: Record<string, [string, string]> = {
  // Hennepin County
  '55305':['Hennepin','1.15'],'55311':['Hennepin','1.15'],'55316':['Hennepin','1.15'],'55317':['Hennepin','1.15'],
  '55331':['Hennepin','1.15'],'55340':['Hennepin','1.15'],'55341':['Hennepin','1.15'],'55343':['Hennepin','1.15'],
  '55344':['Hennepin','1.15'],'55345':['Hennepin','1.15'],'55346':['Hennepin','1.15'],'55347':['Hennepin','1.15'],
  '55348':['Hennepin','1.15'],'55356':['Hennepin','1.15'],'55357':['Hennepin','1.15'],'55364':['Hennepin','1.15'],
  '55369':['Hennepin','1.15'],'55374':['Hennepin','1.15'],'55375':['Hennepin','1.15'],'55384':['Hennepin','1.15'],
  '55387':['Hennepin','1.15'],'55388':['Hennepin','1.15'],'55391':['Hennepin','1.15'],'55392':['Hennepin','1.15'],
  '55401':['Hennepin','1.15'],'55402':['Hennepin','1.15'],'55403':['Hennepin','1.15'],'55404':['Hennepin','1.15'],
  '55405':['Hennepin','1.15'],'55406':['Hennepin','1.15'],'55407':['Hennepin','1.15'],'55408':['Hennepin','1.15'],
  '55409':['Hennepin','1.15'],'55410':['Hennepin','1.15'],'55411':['Hennepin','1.15'],'55412':['Hennepin','1.15'],
  '55413':['Hennepin','1.15'],'55414':['Hennepin','1.15'],'55415':['Hennepin','1.15'],'55416':['Hennepin','1.15'],
  '55417':['Hennepin','1.15'],'55418':['Hennepin','1.15'],'55419':['Hennepin','1.15'],'55420':['Hennepin','1.15'],
  '55422':['Hennepin','1.15'],'55423':['Hennepin','1.15'],'55424':['Hennepin','1.15'],'55425':['Hennepin','1.15'],
  '55426':['Hennepin','1.15'],'55427':['Hennepin','1.15'],'55428':['Hennepin','1.15'],'55429':['Hennepin','1.15'],
  '55430':['Hennepin','1.15'],'55431':['Hennepin','1.15'],'55432':['Hennepin','1.15'],'55435':['Hennepin','1.15'],
  '55436':['Hennepin','1.15'],'55437':['Hennepin','1.15'],'55438':['Hennepin','1.15'],'55439':['Hennepin','1.15'],
  '55441':['Hennepin','1.15'],'55442':['Hennepin','1.15'],'55443':['Hennepin','1.15'],'55444':['Hennepin','1.15'],
  '55445':['Hennepin','1.15'],'55446':['Hennepin','1.15'],'55447':['Hennepin','1.15'],
  // Ramsey County
  '55101':['Ramsey','1.21'],'55102':['Ramsey','1.21'],'55103':['Ramsey','1.21'],'55104':['Ramsey','1.21'],
  '55105':['Ramsey','1.21'],'55106':['Ramsey','1.21'],'55107':['Ramsey','1.21'],'55108':['Ramsey','1.21'],
  '55109':['Ramsey','1.21'],'55110':['Ramsey','1.21'],'55112':['Ramsey','1.21'],'55113':['Ramsey','1.21'],
  '55114':['Ramsey','1.21'],'55115':['Ramsey','1.21'],'55116':['Ramsey','1.21'],'55117':['Ramsey','1.21'],
  '55118':['Ramsey','1.21'],'55119':['Ramsey','1.21'],'55126':['Ramsey','1.21'],'55127':['Ramsey','1.21'],
  '55128':['Ramsey','1.21'],'55130':['Ramsey','1.21'],'55133':['Ramsey','1.21'],'55144':['Ramsey','1.21'],
  '55146':['Ramsey','1.21'],'55155':['Ramsey','1.21'],
  // Dakota County
  '55010':['Dakota','1.02'],'55024':['Dakota','1.02'],'55031':['Dakota','1.02'],'55033':['Dakota','1.02'],
  '55044':['Dakota','1.02'],'55065':['Dakota','1.02'],'55068':['Dakota','1.02'],'55071':['Dakota','1.02'],
  '55075':['Dakota','1.02'],'55076':['Dakota','1.02'],'55077':['Dakota','1.02'],'55085':['Dakota','1.02'],
  '55111':['Dakota','1.02'],'55120':['Dakota','1.02'],'55121':['Dakota','1.02'],'55122':['Dakota','1.02'],
  '55123':['Dakota','1.02'],'55124':['Dakota','1.02'],'55150':['Dakota','1.02'],'55306':['Dakota','1.02'],
  '55337':['Dakota','1.02'],'55378':['Dakota','1.02'],
  // Anoka County
  '55003':['Anoka','0.99'],'55011':['Anoka','0.99'],'55014':['Anoka','0.99'],'55025':['Anoka','0.99'],
  '55038':['Anoka','0.99'],'55040':['Anoka','0.99'],'55070':['Anoka','0.99'],'55092':['Anoka','0.99'],
  '55301':['Anoka','0.99'],'55302':['Anoka','0.99'],'55303':['Anoka','0.99'],'55304':['Anoka','0.99'],
  '55330':['Anoka','0.99'],'55421':['Anoka','0.99'],'55433':['Anoka','0.99'],'55434':['Anoka','0.99'],
  '55448':['Anoka','0.99'],'55449':['Anoka','0.99'],
  // Washington County
  '55001':['Washington','0.98'],'55016':['Washington','0.98'],
  '55042':['Washington','0.98'],'55043':['Washington','0.98'],
  '55047':['Washington','0.98'],'55055':['Washington','0.98'],
  '55073':['Washington','0.98'],'55082':['Washington','0.98'],'55083':['Washington','0.98'],
  '55084':['Washington','0.98'],'55090':['Washington','0.98'],
  '55125':['Washington','0.98'],'55129':['Washington','0.98'],
  // Scott County
  '55020':['Scott','0.96'],'55021':['Scott','0.96'],'55046':['Scott','0.96'],'55050':['Scott','0.96'],
  '55054':['Scott','0.96'],'55352':['Scott','0.96'],'55372':['Scott','0.96'],
  '55379':['Scott','0.96'],
  // Olmsted County (Rochester)
  '55901':['Olmsted','1.05'],'55902':['Olmsted','1.05'],'55903':['Olmsted','1.05'],'55904':['Olmsted','1.05'],
  '55905':['Olmsted','1.05'],'55906':['Olmsted','1.05'],'55920':['Olmsted','1.05'],'55927':['Olmsted','1.05'],
  '55934':['Olmsted','1.05'],'55960':['Olmsted','1.05'],'55976':['Olmsted','1.05'],
  // St. Louis County (Duluth)
  '55801':['St. Louis','1.08'],'55802':['St. Louis','1.08'],'55803':['St. Louis','1.08'],
  '55804':['St. Louis','1.08'],'55805':['St. Louis','1.08'],'55806':['St. Louis','1.08'],
  '55807':['St. Louis','1.08'],'55808':['St. Louis','1.08'],'55810':['St. Louis','1.08'],
  '55811':['St. Louis','1.08'],'55812':['St. Louis','1.08'],
  // Stearns County
  '56301':['Stearns','1.10'],'56302':['Stearns','1.10'],'56303':['Stearns','1.10'],
  '56304':['Stearns','1.10'],'56374':['Stearns','1.10'],'56377':['Stearns','1.10'],
};

// City → [County, TaxRate] fallback lookup
export const MN_CITY_TO_COUNTY: Record<string, [string, string]> = {
  'minneapolis':['Hennepin','1.15'],'edina':['Hennepin','1.15'],'eden prairie':['Hennepin','1.15'],
  'bloomington':['Hennepin','1.15'],'plymouth':['Hennepin','1.15'],'maple grove':['Hennepin','1.15'],
  'brooklyn park':['Hennepin','1.15'],'brooklyn center':['Hennepin','1.15'],'st louis park':['Hennepin','1.15'],
  'saint louis park':['Hennepin','1.15'],'richfield':['Hennepin','1.15'],'hopkins':['Hennepin','1.15'],
  'golden valley':['Hennepin','1.15'],'robbinsdale':['Hennepin','1.15'],'crystal':['Hennepin','1.15'],
  'new hope':['Hennepin','1.15'],'wayzata':['Hennepin','1.15'],'minnetonka':['Hennepin','1.15'],
  'excelsior':['Hennepin','1.15'],'champlin':['Hennepin','1.15'],'osseo':['Hennepin','1.15'],
  'st paul':['Ramsey','1.21'],'saint paul':['Ramsey','1.21'],'maplewood':['Ramsey','1.21'],
  'roseville':['Ramsey','1.21'],'shoreview':['Ramsey','1.21'],'arden hills':['Ramsey','1.21'],
  'new brighton':['Ramsey','1.21'],'north st paul':['Ramsey','1.21'],'white bear lake':['Ramsey','1.21'],
  'little canada':['Ramsey','1.21'],'falcon heights':['Ramsey','1.21'],'vadnais heights':['Ramsey','1.21'],
  'eagan':['Dakota','1.02'],'burnsville':['Dakota','1.02'],'apple valley':['Dakota','1.02'],
  'lakeville':['Dakota','1.02'],'rosemount':['Dakota','1.02'],'inver grove heights':['Dakota','1.02'],
  'south st paul':['Dakota','1.02'],'farmington':['Dakota','1.02'],'hastings':['Dakota','1.02'],
  'mendota heights':['Dakota','1.02'],'west st paul':['Dakota','1.02'],
  'blaine':['Anoka','0.99'],'coon rapids':['Anoka','0.99'],'fridley':['Anoka','0.99'],
  'columbia heights':['Anoka','0.99'],'andover':['Anoka','0.99'],'ham lake':['Anoka','0.99'],
  'anoka':['Anoka','0.99'],'ramsey':['Anoka','0.99'],'lino lakes':['Anoka','0.99'],
  'woodbury':['Washington','0.98'],'cottage grove':['Washington','0.98'],'stillwater':['Washington','0.98'],
  'oakdale':['Washington','0.98'],'forest lake':['Washington','0.98'],'hugo':['Washington','0.98'],
  'lake elmo':['Washington','0.98'],
  'shakopee':['Scott','0.96'],'savage':['Scott','0.96'],'prior lake':['Scott','0.96'],
  'jordan':['Scott','0.96'],'belle plaine':['Scott','0.96'],'new prague':['Scott','0.96'],
  'rochester':['Olmsted','1.05'],'byron':['Olmsted','1.05'],
  'duluth':['St. Louis','1.08'],'hermantown':['St. Louis','1.08'],'hibbing':['St. Louis','1.08'],
  'virginia':['St. Louis','1.08'],'eveleth':['St. Louis','1.08'],
  'st cloud':['Stearns','1.10'],'saint cloud':['Stearns','1.10'],'sartell':['Stearns','1.10'],
  'sauk rapids':['Stearns','1.10'],
};

// County options for dropdown (county name → tax rate)
export const MN_COUNTIES: { label: string; value: string }[] = [
  { label: 'Hennepin (Minneapolis) — 1.15%', value: '1.15' },
  { label: 'Ramsey (St. Paul) — 1.21%', value: '1.21' },
  { label: 'Dakota (Eagan/Burnsville) — 1.02%', value: '1.02' },
  { label: 'Anoka — 0.99%', value: '0.99' },
  { label: 'Washington (Woodbury) — 0.98%', value: '0.98' },
  { label: 'Scott (Shakopee) — 0.96%', value: '0.96' },
  { label: 'Carver (Chanhassen) — 1.01%', value: '1.01' },
  { label: 'Wright — 1.05%', value: '1.05' },
  { label: 'Sherburne — 1.00%', value: '1.00' },
  { label: 'Chisago — 1.05%', value: '1.05' },
  { label: 'Isanti — 1.07%', value: '1.07' },
  { label: 'Olmsted (Rochester) — 1.05%', value: '1.05' },
  { label: 'St. Louis (Duluth) — 1.08%', value: '1.08' },
  { label: 'Stearns (St. Cloud) — 1.10%', value: '1.10' },
  { label: 'Blue Earth (Mankato) — 1.15%', value: '1.15' },
  { label: 'Rice (Northfield/Faribault) — 1.14%', value: '1.14' },
  { label: 'Crow Wing (Brainerd) — 0.93%', value: '0.93' },
  { label: 'Itasca (Grand Rapids) — 1.00%', value: '1.00' },
  { label: 'Otter Tail (Fergus Falls) — 1.05%', value: '1.05' },
  { label: 'Other (enter rate manually)', value: '1.05' },
];

export interface CountyDetectionResult {
  countyName: string;
  taxRate: string;
}

/**
 * Detect county from address, city, or ZIP.
 * Tries ZIP first (most reliable), then city field, then parses address string.
 */
export function detectCounty(
  address: string,
  city: string,
  zip: string
): CountyDetectionResult | null {
  // Try ZIP first
  if (zip && MN_ZIP_TO_COUNTY[zip]) {
    const [countyName, taxRate] = MN_ZIP_TO_COUNTY[zip];
    return { countyName, taxRate };
  }

  // Try city field
  const cityLower = city.trim().toLowerCase();
  if (cityLower && MN_CITY_TO_COUNTY[cityLower]) {
    const [countyName, taxRate] = MN_CITY_TO_COUNTY[cityLower];
    return { countyName, taxRate };
  }

  // Try extracting from full address
  const addressLower = address.trim().toLowerCase();
  if (addressLower) {
    // Try to extract ZIP from address
    const zipMatch = addressLower.match(/\b(55\d{3}|56\d{3})\b/);
    if (zipMatch && MN_ZIP_TO_COUNTY[zipMatch[1]]) {
      const [countyName, taxRate] = MN_ZIP_TO_COUNTY[zipMatch[1]];
      return { countyName, taxRate };
    }

    // Try to match city name in address
    for (const [cityName, data] of Object.entries(MN_CITY_TO_COUNTY)) {
      if (addressLower.includes(cityName)) {
        return { countyName: data[0], taxRate: data[1] };
      }
    }
  }

  return null;
}
